import { OreNavBarWrapper } from '@edenredespana/oreneta'

import { Loader } from '@/Shared/ui/loader'
import { Header, Sidebar } from '@/Shared/ui/navigation'
import { Notification } from '@/Shared/ui/notifications'

import TokenManager from '../../TokenManager/TokenManager'

const PageApp = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <div style={{ display: 'flex' }}>
    <TokenManager />
    <Header />
    <Sidebar />
    <OreNavBarWrapper>{children}</OreNavBarWrapper>
    <Loader />
    <Notification />
  </div>
)

export { PageApp }
